Vendd.Scripts.load(function () {

    Vendd.MessageBus.subscribe(Vendd.Widget.Messages.BindControl, 'x-facebook-widget', function (envelope) {

        var $context = envelope.message.data.context,
        	$wrappers = $('.x-facebook-widget', $context);

        if ($wrappers.length < 1)
            return;

        var $buttons = $('.js-fbsubmit-button', $wrappers);

        if (!Vendd.User.AuthProviders.facebook)
            throw new Error('facebook vendd auth provider not found');

        Vendd.User.AuthProviders.facebook.init();

        $('.x-facebook-widget .js-fbsubmit-button').click(function (e) {
            if (typeof (e.preventDefault) === 'function')
                e.preventDefault();

            Vendd.User.AuthProviders.facebook.login();
        });

    });
});